import type { DeviceNameWithoutDefault, DeviceName } from '@athena-lib/device';
import type { GridColumnSpan, GridColumns } from './types';

export const gridColumnSpansPerColumns: Record<
  DeviceName | 'default',
  Record<GridColumns, string>
> = {
  default: {
    // This probably looks odd but in mobile we only have 2 columns and not 12.
    // The reason for this is because if we have 12 columns in mobile and use col span
    // the width of the gap between the 12 columns takes up so much space that the
    // width of the grid becomes wider than the screen. Even if all grid items span all
    // 12 columns the gaps are still there and take up width.
    1: 'col-span-2 md:col-span-12',
    2: 'col-span-1 md:col-span-6',
    3: 'col-span-1 md:col-span-4',
    4: 'col-span-1 md:col-span-3',
    6: 'col-span-1 md:col-span-2',
    12: 'col-span-1 md:col-span-1',
  },

  sm: {
    1: 'col-span-2',
    2: 'col-span-1',
    3: 'col-span-1',
    4: 'col-span-1',
    6: 'col-span-1',
    12: 'col-span-1',
  },

  md: {
    1: 'md:col-span-12',
    2: 'md:col-span-6',
    3: 'md:col-span-4',
    4: 'md:col-span-3',
    6: 'md:col-span-2',
    12: 'md:col-span-1',
  },

  lg: {
    1: 'lg:col-span-12',
    2: 'lg:col-span-6',
    3: 'lg:col-span-4',
    4: 'lg:col-span-3',
    6: 'lg:col-span-2',
    12: 'lg:col-span-1',
  },
};

export const gridItemColumnSpans: Record<
  DeviceNameWithoutDefault | 'default',
  Record<GridColumnSpan, string>
> = {
  default: {
    // See comment in gridColumnSpansPerColumns.default
    1: 'col-span-1',
    2: 'col-span-1',
    3: 'col-span-1',
    4: 'col-span-1',
    5: 'col-span-1',
    6: 'col-span-1',
    7: 'col-span-2',
    8: 'col-span-2',
    9: 'col-span-2',
    10: 'col-span-2',
    11: 'col-span-2',
    12: 'col-span-2',
  },

  md: {
    1: 'md:col-span-1',
    2: 'md:col-span-2',
    3: 'md:col-span-3',
    4: 'md:col-span-4',
    5: 'md:col-span-5',
    6: 'md:col-span-6',
    7: 'md:col-span-7',
    8: 'md:col-span-8',
    9: 'md:col-span-9',
    10: 'md:col-span-10',
    11: 'md:col-span-11',
    12: 'md:col-span-12',
  },

  lg: {
    1: 'lg:col-span-1',
    2: 'lg:col-span-2',
    3: 'lg:col-span-3',
    4: 'lg:col-span-4',
    5: 'lg:col-span-5',
    6: 'lg:col-span-6',
    7: 'lg:col-span-7',
    8: 'lg:col-span-8',
    9: 'lg:col-span-9',
    10: 'lg:col-span-10',
    11: 'lg:col-span-11',
    12: 'lg:col-span-12',
  },
};

export const gridRowSpans = {
  default: {
    1: 'row-span-1',
    2: 'row-span-1',
    3: 'row-span-1',
    4: 'row-span-1',
    6: 'row-span-1',
  },

  md: {
    1: 'md:row-span-1',
    2: 'md:row-span-2',
    3: 'md:row-span-3',
    4: 'md:row-span-4',
    6: 'md:row-span-5',
  },

  lg: {
    1: 'lg:row-span-1',
    2: 'lg:row-span-2',
    3: 'lg:row-span-3',
    4: 'lg:row-span-4',
    6: 'lg:row-span-5',
  },
};
